<!-- =========================================================================================
  File Name: CompanyGeneralDetails.vue
  Description: Entity Edit account content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-client-maps-form">
    <vs-row>
      <vs-col :class="readonly ? 'readonly-form' : ''">
        <card-page
          card-title="Details"
          :switch-model="model.IsEnabled || false"
        >
          <vue-element-loading :active="busy"></vue-element-loading>
          <vue-form-generator
            class="mt-4"
            ref="form"
            :model="model"
            :options="formOptions"
            :schema="schema"
          />
        </card-page>
        <card-page card-title="Internal Classifications">
          <vue-element-loading :active="busy"></vue-element-loading>
          <vue-form-generator
            class="mt-4"
            ref="formInternalClassifications"
            :model="model"
            :options="formOptions"
            :schema="internalClassificationsSchema"
          />
        </card-page>
        <card-page card-title="Email Addresses">
          <vue-element-loading :active="busy"></vue-element-loading>
          <additive-widget
            ref="formEmailAddresses"
            v-model="model"
            :form-options="formOptions"
            :schema="schemaEmails"
            label="email addresses"
            :readonly="readonly"
            primary-toggle
            primary-field-name="IsPrimaryEmail"
            mandatory
          />
        </card-page>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import FormModelMixin from '@/components/mixins/FormModelMixin';
import CardPage from '../../../components/Views/CardPage';
import AdditiveWidget from '../../../../components/form/fields/AdditiveWidget';
import {
  selectOptions,
  arrayOptions
} from '@/components/form/FormElementOption';
import FormFieldValidationMixin from '../../../../components/mixins/FormFieldValidationMixin';

export default {
  components: {
    CardPage,
    AdditiveWidget
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [FormModelMixin, FormFieldValidationMixin],

  data() {
    return {
      additiveForms: ['formEmailAddresses'],
      model: {
        CompanyName: null,
        CompanyCode: null,
        SalesCountryType_FK: null,
        CompanyGroup_FK: null,
        CompanyType_Entity_FK: null,
        ParentCompany_FK: null,
        SecondaryParentCompany_FK: null,
        CompanyExtension: null,
        CompanyType_LloydsStatus_FK: null,
        CompanyAncestor_FK: null,
        ProducerStatusType_FK: null,
        IsEnabled: false,
        email_addresses: [{
          EmailAddress: null,
          EmailType_FK: null,
          IsPrimaryEmail: null,
        }],
        IsCoverholder: 0,
        IsProducer: 0,
        IsInsurer: 0,
        IsOther: 0,
        IsSubProducer: 0,
        email_addresses: [],
        company_type: {
          CompanyTypeName: 'N/A',
        },
      },
      formReferences: [
        'form',
        'formInternalClassifications',
      ],
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true
      },
      internalClassificationsSchema: {
        groups: [{
          styleClasses: 'w-full',
          fields: [
            {
              type: 'vsCheckbox',
              styleClasses: 'w-1/3',
              label: 'Coverholder',
              model: 'IsCoverholder',
              disabled: () => this.readonly,
              onChanged: () => this.validateFields(['IsProducer', 'IsInsurer', 'IsOther'], 'formInternalClassifications'),
              validator: [
                (value, field, model) => {
                  if (!value && !model.IsProducer && !model.IsInsurer && !model.IsOther
                  ) {
                    return 'Please select at least one classification'
                  }

                  return true;
                }
              ]
            },
            {
              type: 'vsCheckbox',
              styleClasses: 'w-1/3',
              label: 'Producer',
              model: 'IsProducer',
              disabled: () => this.readonly,
              onChanged: () => this.validateFields(['IsCoverholder', 'IsInsurer', 'IsOther'], 'formInternalClassifications'),
              validator: [
                (value, field, model) => {
                  if (!value && !model.IsCoverholder && !model.IsInsurer && !model.IsOther
                  ) {
                    return 'Please select at least one classification'
                  }

                  return true;
                }
              ]
            },
            {
              type: 'vsCheckbox',
              styleClasses: 'w-1/3',
              label: 'Insurer',
              model: 'IsInsurer',
              disabled: () => this.readonly,
              onChanged: () => this.validateFields(['IsCoverholder', 'IsProducer', 'IsOther'], 'formInternalClassifications'),
              validator: [
                (value, field, model) => {
                  if (!value && !model.IsCoverholder && !model.IsProducer && !model.IsOther
                  ) {
                    return 'Please select at least one classification'
                  }

                  return true;
                }
              ]
            },
            {
              type: 'vsCheckbox',
              styleClasses: 'w-1/3',
              label: 'Other',
              model: 'IsOther',
              disabled: () => this.readonly,
              onChanged: () => this.validateFields(['IsCoverholder', 'IsProducer', 'IsInsurer'], 'formInternalClassifications'),
              validator: [
                (value, field, model) => {
                  if (!value && !model.IsCoverholder && !model.IsProducer && !model.IsInsurer
                  ) {
                    return 'Please select at leaset one classification'
                  }

                  return true;
                }
              ]
            },
            {
              type: 'vsCheckbox',
              styleClasses: 'w-1/3',
              label: 'Sub-Producer',
              model: 'IsSubProducer',
              disabled: () => this.readonly,
            },
          ]
        }]
      },
      schemaEmails: {
        groups: [
          {
            styleClasses: 'w-full',
            fields: [
              {
                model: 'email_addresses',
                ...arrayOptions,
                hideAddButton: this.readonly,
                showRemoveButton: !this.readonly,
                items: {
                  type: 'object',
                  styleClasses: 'w-full',
                  schema: {
                    groups: [
                      {
                        styleClasses: 'w-full',
                        fields: [
                          {
                            disabled: () => this.readonly,
                            type: 'vueMultiSelect',
                            inputType: 'text',
                            styleClasses: 'w-1/4',
                            label: 'Email Type',
                            model: 'EmailType_FK',
                            values: () => this.emailOptions,
                            selectOptions,
                            required: () => !this.readonly,
                            onChanged: () => {
                              this.validateAdditiveField(
                                'EmailAddress',
                                'email_addresses',
                                'formEmailAddresses'
                              );
                            },
                            validator: ['required']
                          },
                          {
                            disabled: () => this.readonly,
                            type: 'input',
                            inputType: 'email',
                            styleClasses: 'w-1/2',
                            label: 'Email Address',
                            model: 'EmailAddress',
                            required: () => !this.readonly,
                            onChanged: () => {
                              // This is so that all other EmailAddress fields get validated (and nothing just this one)
                              this.validateAdditiveField(
                                'EmailAddress',
                                'email_addresses',
                                'formEmailAddresses'
                              );
                            },
                            validator: [
                                'required',
                                (value, field, model) => {
                                  let withSameType = model.EmailType_FK
                                    ? this.model.email_addresses.filter(entity => (entity.EmailType_FK && entity.EmailType_FK.id) === model.EmailType_FK.id)
                                    : [];

                                  if (withSameType.filter(entity => entity.EmailAddress === value).length > 1) {
                                    return 'Email already assigned!';
                                  }

                                  return true;
                                },
                            ]
                          }
                        ]
                      }
                    ]
                  }
                }
              }
            ]
          }
        ]
      },
      schema: {
        groups: [
          {
            styleClasses: 'w-full',
            fields: [
              {
                type: 'input',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'Entity Name',
                model: 'CompanyName',
                disabled: () => this.readonly,
                required: () => !this.readonly,
                validator: 'required'
              },
              {
                type: 'vueMultiSelect',
                styleClasses: 'w-1/3',
                label: 'Entity Type',
                model: 'CompanyExtension',
                disabled: () => this.readonly,
                values: () => this.entityTypeOptions,
                selectOptions: {
                  showLabels: false,
                  hideSelected: false,
                },
                required: () => !this.readonly,
                validator: 'required'
              },
              {
                type: 'input',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'Entity Code',
                max: 10,
                model: 'CompanyCode',
                disabled: () => this.readonly,
                required: () => !this.readonly,
                validator: ['required', 'string']
              },
              {
                type: 'vueMultiSelect',
                styleClasses: 'w-1/3',
                label: 'Sales Country',
                model: 'SalesCountryType_FK',
                disabled: () => this.readonly,
                values: () => this.salesCountryOptions,
                selectOptions,
                required: () => !this.readonly,
                validator: 'required'
              },
              {
                type: 'vueMultiSelect',
                styleClasses: 'w-1/3',
                label: 'Reporting Group',
                model: 'CompanyGroup_FK',
                disabled: () => this.readonly,
                values: () => this.groupOptions,
                selectOptions,
                required: () => !this.readonly,
                validator: 'required'
              },
            ]
          },
          {
            styleClasses: 'w-full',
            fields: [
              {
                type: 'vueMultiSelect',
                styleClasses: 'w-1/3',
                label: 'Previous Entity',
                model: 'CompanyAncestor_FK',
                disabled: () => this.readonly,
                values: () => this.asyncParentEntityOptions,
                selectOptions: {
                  ...selectOptions,

                  // Async Search
                  hideSelected: false,
                  searchable: true,
                  localSearch: false,
                  internalSearch: false,
                  clearOnSelect: false,
                  onSearch: function(searchQuery, id, options) {
                    if (searchQuery.length === 0) {
                      this.asyncParentEntityOptions = []
                    } else {
                      this.asyncParentEntityOptions = this.parentEntityOptions.filter((element, index, array) => {
                        return element.name.toLowerCase().includes(searchQuery.toLowerCase())
                      })
                    }
                  }.bind(this),
                },
              },
              {
                type: 'vueMultiSelect',
                styleClasses: 'w-1/3',
                label: 'Primary Parent Entity',
                model: 'ParentCompany_FK',
                disabled: () => this.readonly,
                values: () => this.asyncParentEntityOptions,
                selectOptions: {
                  ...selectOptions,

                  // Async Search
                  hideSelected: false,
                  searchable: true,
                  localSearch: false,
                  internalSearch: false,
                  clearOnSelect: false,
                  onSearch: function(searchQuery, id, options) {
                    if (searchQuery.length === 0) {
                      this.asyncParentEntityOptions = []
                    } else {
                      this.asyncParentEntityOptions = this.parentEntityOptions.filter((element, index, array) => {
                        return element.name.toLowerCase().includes(searchQuery.toLowerCase())
                      })
                    }
                  }.bind(this),
                },
              },
              {
                type: 'vueMultiSelect',
                styleClasses: 'w-1/3',
                label: 'Secondary Parent Entity',
                model: 'SecondaryParentCompany_FK',
                disabled: () => this.readonly,
                values: () => this.asyncParentEntityOptions,
                selectOptions: {
                  ...selectOptions,

                  // Async Search
                  hideSelected: false,
                  searchable: true,
                  localSearch: false,
                  internalSearch: false,
                  clearOnSelect: false,
                  onSearch: function(searchQuery, id, options) {
                    if (searchQuery.length === 0) {
                      this.asyncParentEntityOptions = []
                    } else {
                      this.asyncParentEntityOptions = this.parentEntityOptions.filter((element, index, array) => {
                        return element.name.toLowerCase().includes(searchQuery.toLowerCase())
                      })
                    }
                  }.bind(this),
                },
              },
              {
                type: 'vueMultiSelect',
                styleClasses: 'w-1/3',
                label: 'Classification',
                model: 'CompanyType_Entity_FK',
                disabled: () => this.readonly,
                values: () => this.companyTypes,
                selectOptions,
                required: () => !this.readonly,
                validator: 'required'
              },
              {
                type: 'vueMultiSelect',
                styleClasses: 'w-1/3',
                label: 'LLoyds Status',
                model: 'CompanyType_LloydsStatus_FK',
                disabled: () => this.readonly,
                required: () => !this.readonly,
                validator: 'required',
                values: () => this.companyTypeOptions,
                selectOptions
              },
              {
                type: 'vueMultiSelect',
                styleClasses: 'w-1/3',
                label: 'Producer Status',
                model: 'ProducerStatusType_FK',
                disabled: () => this.readonly,
                required: () => !this.readonly,
                validator: 'required',
                values: () => this.producerStatusOptions,
                selectOptions
              },
              {
                type: 'input',
                inputType: 'text',
                styleClasses: 'w-1/3',
                label: 'Producer Type',
                model: 'CompanyTypeName',
                disabled: () => this.readonly,
                visible: () => this.readonly,
              }
            ]
          }
        ]
      },

      groupOptions: [],
      asyncParentEntityOptions: [],
      parentEntityOptions: [],
      companyTypeOptions: [],
      producerStatusOptions: [],
      salesCountryOptions: [],
      emailOptions: [],
      companyTypes: [],
      entityTypeOptions:[
        'Srl',
        'Srlu',
        'Snc',
        'Spa',
        'Srls',
        'Sas',
        'SS',
        'Sl',
        'Ditta Individuale',
        'Not Applicable',
      ],
      options: [
        {
          endpoint: () => this.$api.companyGroups.list(),
          optionsFieldName: 'groupOptions',
          nameFieldName: 'CompanyGroupName',
          idFieldName: 'CompanyGroup_FK'
        },
        {
          endpoint: () => this.$api.companies.all({params: { 'whereNot[id]': this.value.id }}),
          optionsFieldName: 'parentEntityOptions',
          nameFieldName: 'CompanyName',
          idFieldName: ['ParentCompany_FK', 'CompanyAncestor_FK', 'SecondaryParentCompany_FK'],
          additionalFields: ['CompanyCode']
        },
        {
          endpoint: () => this.$api.companyTypes.list({ params: { FilterType: 2 } }),
          optionsFieldName: 'companyTypeOptions',
          nameFieldName: 'CompanyTypeName',
          idFieldName: 'CompanyType_LloydsStatus_FK'
        },
        {
          endpoint: () => this.$api.companies.producerStatuses(),
          optionsFieldName: 'producerStatusOptions',
          nameFieldName: 'Type',
          idFieldName: 'ProducerStatusType_FK'
        },
        {
          endpoint: () => this.$api.companies.salesCountries(),
          optionsFieldName: 'salesCountryOptions',
          nameFieldName: 'Type',
          idFieldName: 'SalesCountryType_FK'
        },
        {
          endpoint: () => this.$api.companyEmailAddress.getOptions(),
          optionsFieldName: 'emailOptions',
          nameFieldName: 'Type',
          idFieldName: 'EmailType_FK',
          modelArrayName: 'email_addresses'
        },
        {
          endpoint: () => this.$api.companyTypes.list({ params: { FilterType: 1 } }),
          optionsFieldName: 'companyTypes',
          nameFieldName: 'CompanyTypeName',
          idFieldName: 'CompanyType_Entity_FK'
        }
      ]
    };
  },
};
</script>
